import type { AccessoryDefinition } from "./AccessoryDefinition";
import type { ISunlabCaseDefinition } from "./ICaseDefinition/ISunlabCaseDefinition";
import type { SunlabsHandleDefinition } from "./SunlabsHandleDefiniton";
import type { SunlabsHingeDefinition } from "./SunlabsHingeDefinition";
import type { SunlabsSectionDefinition } from "./SunlabsSectionDefinition";
import type { WheelDefinition } from "./WheelDefinition";

/**
 * Raw CaseConf / Sunlabs payload, persisted verbatim as `PositionInfo.megaCaseInfo`.
 *
 * Optionality here mirrors {@link ISunlabCaseDefinition}: every field a case type
 * may not carry is optional *and* nullable. The index signature keeps the
 * generated zod schema permissive (`.catchall` instead of `.strict`) so that a
 * field added upstream does not make newly imported positions unsaveable.
 */
export interface SunlabCaseDefinition extends ISunlabCaseDefinition {
  [key: string]: unknown;
  Accessories?: AccessoryDefinition[] | null;
  CaseId: number;
  CornerBody?: string | null;
  CornerCap: string;
  Count: number;
  CustomerId: number;
  CustomerName: string;
  Depth: number;
  EdgeProtectionBody?: string | null;
  EdgeProtectionBodyConfiguration: string;
  EdgeProtectionBodyWidth: number;
  EdgeProtectionCap: string;
  EdgeProtectionCapConfiguration: string;
  EdgeProtectionCapWidth: number;
  Fastener: string;
  FastenerConfiguration: string;
  FoamBody?: string | null;
  FoamBodyThickness?: number | null;
  FoamCap?: string | null;
  FoamCapThickness?: number | null;
  Handles: SunlabsHandleDefinition[];
  Height: number;
  HeightUnits?: number | null;
  Hinges: SunlabsHingeDefinition[];
  Keyboard?: string | null;
  KeyboardBrandAndModel?: string | null;
  LCornerCap?: string | null;
  LCornerBody?: string | null;
  OptionAccessoriesCompartment?: boolean | null;
  OptionAdditionalBackRackRail?: boolean | null;
  OptionLeatherHandle?: boolean | null;
  OptionPlayableInCase?: boolean | null;
  OptionRemovableCap?: boolean | null;
  OptionStackable?: boolean | null;
  OptionTrolleyFunction?: boolean | null;
  OrderDate: string;
  Panel: string;
  PanelColor: string;
  PanelThickness: number;
  PriceSale: number;
  PriceSaleCalculationData?: unknown;
  Sections: SunlabsSectionDefinition[];
  SizeKeyCount?: number | null;
  Type: string;
  Wheels?: WheelDefinition[] | null;
  Width: number;
  caseType?: string | null;
}

/** Customer field for CaseConf / Sunlabs imports; matches legacy `CaseConfApi.fetchOrderFromCaseConf`. */
export const LEGACY_THON_CUSTOMER_DISPLAY = "Thon- ";
